import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import CountdownTimer from "./CountdownTimer";
import pen from "../../../assets/food/penblack.svg";
import { getResponsiveClasses } from "./ResponsiveClasses";
import "swiper/css";
import "swiper/css/navigation";

const OrderSwiper = ({ orderFnb, pageName, APIStatus }) => {
    const navigate = useNavigate();
    const [prepareMultiOrderStatus, setPrepareMultiOrderStatus] = useState([]);
    const [redTimers, setRedTimers] = useState({});
    const { currentClasses, getWindowWidth } = getResponsiveClasses();
    const onSeatType = localStorage.getItem("onSeatType");
    const redTimer = JSON.parse(localStorage.getItem("redTimer") * 60) || [];
    const theatreId = JSON.parse(localStorage.getItem("TheatreId"));


    useEffect(() => {
        const cleanExpiredData = () => {
            const currentTime = Date.now();

            // === 1. Clean prepareMultiOrderStatus ===
            // const storedOrders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
            // const updatedOrders = storedOrders.map(order => {
            //     const activeVouchers = (order.activateVoucher || []).filter(voucher =>
            //         new Date(voucher.expiryDate).getTime() > currentTime
            //     );
            //     return {
            //         ...order,
            //         activateVoucher: activeVouchers.length ? activeVouchers : null
            //     };
            // }).filter(order => order.activateVoucher?.length > 0);
            // localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));
            // setPrepareMultiOrderStatus(updatedOrders);


            const storedOrders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

            const updatedOrders = storedOrders.map(order => {
                const isFoodItem = order?.foodItems?.length > 0;
                const isVoucherItem = order?.activateVoucher?.length > 0;

                // Filter active vouchers (not expired)
                const activeVouchers = (order.activateVoucher || []).filter(voucher =>
                    new Date(voucher.expiryDate).getTime() > currentTime
                );

                // For uniform access in JSX (filteredOrders[0]?.voucher)
                // const selectedVoucher = activeVouchers.length > 0 ? activeVouchers[0] : null;

                return {
                    ...order,
                    activateVoucher: activeVouchers.length > 0 ? activeVouchers : null,
                    // voucher: selectedVoucher, // added for uniform access
                    isFoodItem,
                    isVoucherItem
                };
            }).filter(order =>
                (order.isVoucherItem && order.activateVoucher?.length > 0) ||
                (order.isFoodItem && order.foodItems?.length > 0)
            );

            localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));
            console.log(updatedOrders, "updatedOrders")
            setPrepareMultiOrderStatus(updatedOrders);
            // === 2. Clean storeAllOfferData ===
            const storedOffers = JSON.parse(localStorage.getItem("storeAllOfferData")) || [];
            const filteredOffers = storedOffers.filter(item =>
                new Date(item.expiryDate).getTime() > currentTime
            );
            // console.log(filteredOffers)
            localStorage.setItem("storeAllOfferData", JSON.stringify(filteredOffers));

            // === 3. Clean timers + update isRed map ===
            const timerStorage = JSON.parse(localStorage.getItem("timers")) || {};
            let updatedTimers = {};
            let validTimers = {};

            Object.entries(timerStorage).forEach(([timerId, timerData]) => {
                const timeRemaining = (timerData.expiry - currentTime) / 1000;
                if (timeRemaining > 0) {
                    validTimers[timerId] = {
                        expiry: timerData.expiry,
                        isRed: timeRemaining <= redTimer
                    };
                    updatedTimers[timerId] = { isRed: timeRemaining <= redTimer };
                }
            });

            localStorage.setItem("timers", JSON.stringify(validTimers));
            setRedTimers(updatedTimers);
        };

        // Initial cleanup on mount
        cleanExpiredData();

        // Run cleanup repeatedly
        const interval = setInterval(cleanExpiredData, 1000); // Every 10 seconds
        return () => clearInterval(interval);
    }, []);

    const calculateDuration = (voucher) => {
        if (!voucher?.activatedDate || !voucher?.expiryDate) return 0;
        // console.log(voucher)
        const startTime = new Date(voucher.activatedDate).getTime();
        const endTime = new Date(voucher.expiryDate).getTime();

        if (isNaN(startTime) || isNaN(endTime)) return 0;

        return Math.max((endTime - startTime) / 1000, 0); // in seconds
    };

    const filteredOrders = prepareMultiOrderStatus?.flatMap((item) => {
        if (!item?.storeAllOfferData || !item?.activateVoucher?.length) {
            return [];
        }

        const processVoucher = (voucher) => ({
            theatreId: voucher?.theatreId,
            en_bid: item?.en_bid,
            voucher: voucher
        });

        if (pageName === "FBOptionPage") {
            return item.activateVoucher
                .filter(v => v?.isRedeem !== true)
                .map(processVoucher);
        } else {
            return item.activateVoucher
                .filter(v => v?.theatreId === theatreId && v?.isRedeem !== true)
                .map(processVoucher);
        }
    }) || [];
    // console.log(filteredOrders[0]?.voucher)

    return (
        <div>
            {prepareMultiOrderStatus?.length > 0 && (
                <div className="vchrLanding">
                    <div className={`pyo-maindiv ${pageName}`}
                    >
                        {pageName === "offerPage" && filteredOrders?.length > 0 && (
                            <section className='offerTimer ofractv' style={{ width: "calc(100%)" }}>
                                <CountdownTimer className={`orderstatusTimer`} timerId={filteredOrders[0]?.voucher?.voucherNo} duration={calculateDuration(filteredOrders[0]?.voucher)} pageName={pageName} title="Offers expires in" count={true} APIStatus={APIStatus} />
                            </section>
                        )}
                        {(pageName === "FBOptionPage" || orderFnb) && (
                            <Swiper
                                spaceBetween={
                                    prepareMultiOrderStatus.filter(
                                        (item) => item.deliveryMode === "ONSEAT" && item.currentStatus).length > 0
                                        ? 5
                                        : 0
                                }
                                slidesPerView={
                                    prepareMultiOrderStatus.filter(
                                        (item) => item.deliveryMode === "ONSEAT" && item.currentStatus).length > 1
                                        ? getWindowWidth
                                            ? 1
                                            : 1.1
                                        : 1.1
                                }
                                centeredSlides={true}
                                loop={false}
                                navigation
                                modules={[Navigation]}
                            >
                                {pageName === "FBOptionPage" && filteredOrders?.length > 0 && (
                                    <SwiperSlide>
                                        <CountdownTimer
                                            className={`orderstatusTimer ${redTimers[filteredOrders[0]?.voucher?.voucherNo]?.isRed ? "red-timer" : ""}`}
                                            timerId={filteredOrders[0]?.voucher?.voucherNo}
                                            duration={calculateDuration(filteredOrders[0]?.voucher)}
                                            pageName={pageName}
                                            title="Offers expires in"
                                            count={true}
                                        />
                                    </SwiperSlide>
                                )}
                                {orderFnb && prepareMultiOrderStatus.filter((item) => item.deliveryMode === "ONSEAT" && item.currentStatus && item?.currentStatus?.toLowerCase() !== "delivered" && !item?.storeAllOfferData).map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="pyo-inndiv">
                                            <img src={pen} alt="pen" />
                                            <div className="fdDisc">
                                                <p className="pyo-ptag">
                                                    {item?.currentStatus}
                                                </p>
                                                <p className="fbitms">{item?.foodItems?.[0]?.name}</p>
                                            </div>
                                            <button
                                                onClick={() =>
                                                    navigate(`/order-status?bookingid=${item.en_bid}`)
                                                }
                                                className="pyo-btn"
                                            >
                                                View Status
                                            </button>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default OrderSwiper
